import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

import messages, { FormattedMessage, withValues } from 'shared/messages/messages';
import config from 'shared/config/config';

import {
  getLocalizedDate
} from 'app/utils/Utils';

import {
  getStore
} from 'shared/services/Store';

import {
  formatCurrency,
  renderPurchaseDescription
} from 'shared/services/PriceService';

import {
  getSelectedCalculations
} from 'shared/selectors/cartSelectors';

import {
  HAGGLE_CHECKOUT_TYPE,
  KIOSK_PRICING_CHECKOUT_TYPE
} from 'app/utils/Constants';

import {
  LEGACY_PRINT_MODE
} from 'shared/utils/Constants';

const styles = () => ({
  header: {
    fontSize: '1.3rem',
    fontWeight: 700,
    textAlign: 'left',
    fontFamily: config.root_font_family
  },
  purchaseDetails: {
    width: '100%',
    textAlign: 'left',
    fontSize: '0.9rem',
    marginBottom: '1rem',
    borderTop: '1px solid rgba(0, 0, 0, 0.1)',
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
    fontFamily: config.root_font_family
  },
  purchaseDetailsCol: {
    padding: '0.5rem 0'
  },
  purchaseDetailsAmountCol: {
    width: '40%',
    textAlign: 'right',
    padding: '0.5rem 0'
  },
  savings: {
    fontStyle: 'oblique'
  },
  p: {
    width: '100%',
    textAlign: 'left',
    marginTop: '0.5rem !important',
    marginBottom: '0.5rem !important',
    fontSize: '0.9rem',
    fontFamily: config.root_font_family
  },
  div: {
    padding: '0.5rem 0'
  },
  ul: {
    listStyleType: 'square',
    padding: '0 0 0 1rem'
  }
});

class PurchaseDetails extends React.Component {
  constructor(props) {
    super(props);

    const { jobs } = getStore();
    this.jobsExist = jobs.allIds.length;
  }

  getMarketplaceLineItem() {
    const { settings } = this.props;
    const {
      label,
      discount_applied,
      discount_label
    } = this.props.calculations;

    let formattedLabel = <FormattedMessage {...label} />;

    if (discount_label && discount_label.id) {
      let formattedDiscount = <FormattedMessage {...withValues(discount_label, Object.assign(discount_label.values, {"show_change": settings.show_change}))} />;
      return <span>{formattedLabel} ({formattedDiscount})</span>;
    }

    return formattedLabel;
  }

  renderPurchaseComplete() {
    const { classes, purchases, settings, locale } = this.props;

    if (!purchases.length) {
      return null;
    }

    let total = 0;
    let rows = [];

    let getLine = purchase => {
      const {
        quantity,
        print_count,
        unlock_all_applied,
        created_at
      } = purchase;

      let description = renderPurchaseDescription(quantity, print_count, unlock_all_applied, settings.prints_enabled);
      let noWrap = { whiteSpace: 'nowrap' };
      let timestamp = <FormattedMessage {...withValues(messages.cart_on_date, { date: getLocalizedDate(locale, created_at) })} />;

      return <span>{description} <span style={noWrap}>{timestamp}</span></span>;
    }

    for (let purchase of purchases) {
      total += purchase.total;

      let line = getLine(purchase);
      let amount = (
        <span>
          {formatCurrency(purchase.total, purchase.stripe_currency, settings.show_change)}
          {
            purchase.tax > 0 &&
            <p>
              {" (" + formatCurrency(purchase.tax, purchase.stripe_currency, settings.show_change) + " tax)"}
            </p>
          }
        </span>
      );

      rows.push((
        <tr key={purchase.id}>
          <td className={classes.purchaseDetailsCol}>
            {line}
          </td>
          <td className={classes.purchaseDetailsAmountCol}>
            {amount}
          </td>
        </tr>
      ));
    }

    let currency = purchases[0].stripe_currency;
    let totalFormatted = formatCurrency(total, currency, settings.show_change);

    let purchaseDetails = (
      <div>
        <table className={`table ${classes.purchaseDetails}`}>
          {rows}
          <tr>
            <td className={classes.purchaseDetailsCol}>
              <b>
                <FormattedMessage {...messages.cart_total} />
              </b>
            </td>
            <td className={classes.purchaseDetailsAmountCol}>
              <b>{totalFormatted}</b>
            </td>
          </tr>
        </table>
      </div>
    );

    let header = null;
    if (!this.props.hideHeader) {
      header = (
        <p className={classes.header}>
          <FormattedMessage {...messages.kiosk_order_details_header} />
        </p>
      );
    }

    return (
      <div>
        {header}
        {purchaseDetails}
      </div>
    );
  }

  render() {
    const {
      classes,
      settings,
      user,
      complete,
      moments,
      selectedMomentIds,
      pricingModel,
      currency,
      calculations,
      showPriceGuide,
      condensed,
      purchaseRequest,
      hideLinkMessage,
      purchases,
      selectedPrintMomentIds
    } = this.props;

    if (!user) {
      return null;
    }

    if (complete) {
      return this.renderPurchaseComplete();
    }

    let header = null;
    if (!this.props.hideHeader) {
      header = (
        <div>
          <p className={classes.header}>
            <FormattedMessage {...messages.kiosk_order_details_header} />
          </p>
          <hr />
        </div>
      );
    }
    let noAmountCheckoutTypes = [HAGGLE_CHECKOUT_TYPE, KIOSK_PRICING_CHECKOUT_TYPE];
    let priceGuide = null;
    if (showPriceGuide) {
      let boughtAll = false;
      for (let purchase of purchases) {
        if (purchase.buy_all_applied) {
          boughtAll = true;
        }
      }

      if (boughtAll) {
        priceGuide = <p className={classes.p}><FormattedMessage {...messages.kiosk_price_guide_instructions_unlocked} /></p>;

      } else {
        let discounts;
        if (this.props.discounts) {
          let liStyle = {
            textAlign: 'left'
          }

          discounts = this.props.discounts.map(({ message: { id, values } }) => ((
            <li style={liStyle}>
              <FormattedMessage {...withValues(messages[id], Object.assign(values, { "show_change": settings.show_change }))} />
            </li>
          )));
        }

        let discountSection = null;
        let discountTitle = null;
        if (discounts && discounts.length) {
          discountTitle = <FormattedMessage {...messages.kiosk_purchase_details_discounts_offered} />
          if (pricingModel === 3) {
            discountTitle = <FormattedMessage {...messages.kiosk_purchase_details_packages_offered} />
          }
          discountSection = (
            <div className={classes.div}>
              <p className={classes.p}>{discountTitle}</p>
              <ul className={classes.ul}>
                {discounts}
              </ul>
            </div>
          );
        }

        priceGuide = (
          <div>
            <hr />
            <div className={classes.div}>
              <p className={classes.p}><FormattedMessage {...messages.kiosk_purchase_details_standard_price} /></p>
              <p className={classes.p}>
                <FormattedMessage {...withValues(messages.kiosk_purchase_details_per_image, {"show_change": settings.show_change, "price": calculations?.price_per_unit, "currency": calculations?.currency})} />
              </p>
            </div>
            {discountSection}
          </div>
        );
      }
    }

    let printInstructions = null;
    if (noAmountCheckoutTypes.includes(settings.checkout_type) && settings.print_mode === LEGACY_PRINT_MODE) {
      printInstructions = (
        <p className={classes.p}>
          <FormattedMessage {...messages.kiosk_order_details_instructions_prints} />
        </p>
      );
    }

    let instructions = (
      <div>
        <p className={classes.p}>
          <FormattedMessage {...messages.kiosk_order_details_instructions} />
        </p>
        {printInstructions}
      </div>
    );

    let linkMsg = null;
    if (!hideLinkMessage) {
      linkMsg = (
        <p className={classes.p}>
          <FormattedMessage {...messages.kiosk_order_details_instructions_email} />
        </p>
      );
    }

    // todo - review how this works
    //let imageCount;
    //if (this.jobsExist) {
    //  imageCount = moments.allIds.length;
    //} else {
    //  imageCount = selectedMomentIds.length;
    //}
    let imageCount = selectedMomentIds.length;
    let printCount = selectedPrintMomentIds.length;

    // if there are no images selected, then show an empty cart message.
    // also if this is haggle checkout type and a price hasn't been approved,
    // then don't show selected images price
    let noSelectedImages = (imageCount + printCount) === 0;
    //let noImages = !moments.allIds.length;
    let noApprovedPrice = noAmountCheckoutTypes.includes(settings.checkout_type) &&
      (!purchaseRequest || !purchaseRequest.id);

    if (noSelectedImages || noApprovedPrice) {
      let msg = null, readout = null;

      if (noSelectedImages) {
        let emptyMsg;
        if (this.jobsExist) {
          emptyMsg = messages.kiosk_order_details_instructions_cart_empty_more_images;
        } else {
          emptyMsg = messages.kiosk_order_details_instructions_cart_empty;
        }

        msg = (
          <div>
            <p className={classes.p}>
              <FormattedMessage {...emptyMsg} />
            </p>
            {instructions}
          </div>
        );

      } else {
        let description;
        if (noAmountCheckoutTypes.includes(settings.checkout_type)) {
          description = renderPurchaseDescription(imageCount, printCount, false, true);
        } else {
          description = this.getMarketplaceLineItem();
        }

        readout = (
          <table className={classes.purchaseDetails}>
            <tr>
              <td className={classes.purchaseDetailsCol}>
                {description}
              </td>
            </tr>
          </table>
        );
      }

      return (
        <div>
          {header}
          {readout}
          {msg}
          {linkMsg}
          {priceGuide}
        </div>
      );
    }

    let description, lineFormatted, totalFormatted, couponAmount, taxAmount, taxRate;
    if (purchaseRequest && purchaseRequest.id) {
      const {
        unlock_all,
        print_count,
        moment_count,
        sub_total,
        amount,
        tax,
        tax_rate
      } = purchaseRequest;

      description = renderPurchaseDescription(moment_count, print_count, unlock_all, settings.prints_enabled)
      lineFormatted = formatCurrency(sub_total, currency, settings.show_change);
      totalFormatted = formatCurrency(amount, currency, settings.show_change);
      taxAmount = tax;
      taxRate = tax_rate;

    } else {
      description = this.getMarketplaceLineItem();
      lineFormatted = formatCurrency(calculations.raw_total, currency, settings.show_change);
      totalFormatted = formatCurrency(calculations.total, currency, settings.show_change);

      if (calculations?.discount_coupon_value) {
        if (calculations?.discount_coupon_type === 0) {
          couponAmount = (calculations.discount_coupon_value / 100) + '%'
        } else {
          couponAmount = formatCurrency(calculations.discount_coupon_value, currency, settings.show_change)
        }
      }
      taxAmount = calculations?.tax;
      taxRate = calculations?.tax_rate;
    }

    let lineItem = (
      <tr>
        <td className={classes.purchaseDetailsCol}>
          {description}
        </td>
        <td className={classes.purchaseDetailsAmountCol}>
          <b>{lineFormatted}</b>
        </td>
      </tr>
    );

    let couponItem = (
      <tr>
        <td className={classes.purchaseDetailsCol}>{"Code: " + calculations?.discount_coupon_code}</td>
        <td className={classes.purchaseDetailsAmountCol}>
          {couponAmount}
        </td>
      </tr>
    )

    let taxLineItem = (
      <tr>
        <td className={classes.purchaseDetailsCol}>Tax{" (" + taxRate + "%)"}</td>
        <td className={classes.purchaseDetailsAmountCol}>
          {formatCurrency(taxAmount, currency, settings.show_change)}
        </td>
      </tr>
    )

    if (condensed) {
      return (
        <div>
          {header}
          <table className={classes.purchaseDetails}>
            {lineItem}
            {
              couponAmount &&
              couponItem
            }
            {
              taxAmount > 0 &&
              taxLineItem
            }
          </table>
        </div>
      );
    }

    return (
      <div>
        {header}
        <table className={classes.purchaseDetails}>
          {lineItem}
          {
            couponAmount &&
            couponItem
          }
          {
            taxAmount > 0 &&
            taxLineItem
          }
          <tr>
            <td className={classes.purchaseDetailsCol}>
              <FormattedMessage {...messages.kiosk_purchase_details_total} />
            </td>
            <td className={classes.purchaseDetailsAmountCol}>
              <b>{totalFormatted}</b>
            </td>
          </tr>
        </table>
        {linkMsg}
        {priceGuide}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.kioskReducer.user,
  selectedMomentIds: state.cartReducer.selectedMomentIds,
  settings: state.kioskReducer.settings,
  moments: state.cartReducer.moments,
  purchases: state.cartReducer.purchases,
  calculations: getSelectedCalculations(state),
  pricingModel: state.cartReducer.calculations.pricing_model,
  currency: state.cartReducer.calculations.currency,
  discounts: state.cartReducer.calculations.discounts,
  purchaseRequest: state.cartReducer.purchaseRequest,
  selectedPrintMomentIds: state.cartReducer.selectedPrintMomentIds,
  locale: state.messagesReducer.locale
});

export default connect(mapStateToProps)(withStyles(styles, { withTheme: true })(PurchaseDetails));
